export enum SectionJumpIdentifiers {
  Cover = "cover",
  Payout = "Payout",
  Revenues = "revenues",
  Liquidity = "liquidity",
  Financials = "financials",
  Discussions = "discussions",
}
